import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'dynamic-form-builder',
  template:`
    <form [formGroup]="formGroup">
      <div class="box-body">
      <div class="col-md-12">
        <div *ngFor="let field of fields">
            <field-builder [field]="field" [form]="formGroup"></field-builder>
        </div>
      </div>
      </div>
      <!-- <div class="box-footer text-center">
        <button type="submit" [disabled]="!form.valid" class="btn btn-primary">Save</button> 
      </div> -->
    </form>
  `,
})
export class DynamicFormBuilderComponent implements OnInit {
  @Output() onSubmit = new EventEmitter();
  @Input() fields: any[] = [];
  @Input()  formGroup: FormGroup;
  constructor() { }

  ngOnInit() {
    let fieldsCtrls = {};
    for (let f of this.fields) {
      if (f.type != 'checkbox') {
        fieldsCtrls[f.name] = new FormControl(f.value || '', Validators.required)
      } else {
        let opts = {};
        for (let opt of f.options) {
          opts[opt.key] = new FormControl(opt.value);
        }
        fieldsCtrls[f.name] = new FormGroup(opts)
      }
    }
    //this.form = new FormGroup(fieldsCtrls);
  }

  func(){
    console.log(this.formGroup.value);
    
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/dynamic-form-builder/dynamic-form-builder.component.ts